// Typed static client for the /api/SigTranslation/* endpoints.
// All-static, returns typed data (never a raw AxiosResponse), rethrows errors.
// Follows the PositiveIdService precedent. Call sites keep their own swallow.

import axios from 'axios'

/** One candidate paraphrase of a prescription's directions. */
export interface SigParaphrase {
    id: string
    token: string
}

/** The sig-translation lookup response for a set of directions. */
export interface SigTranslations {
    paraphrases: SigParaphrase[]
    token: string
}

export class SigTranslationService {
    /** Candidate translations/paraphrases for the given directions + drug. */
    static async getTranslations(directions: string, drugName: string, ndc11: string): Promise<SigTranslations> {
        const response = await axios.get<SigTranslations>('/api/SigTranslation/Translations', {
            params: { directions, drugName, ndc11 },
        })
        return response.data
    }

    /** The translated directions text for a chosen paraphrase id. */
    static async translate(paraphraseId: string, directions: string, patientId: number): Promise<string> {
        const response = await axios.get<string>(`/api/SigTranslation/Translations/${paraphraseId}`, {
            params: { directions, patientId },
        })
        return response.data
    }
}

export default SigTranslationService
